/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Tier_Lists_DescriptionInputs */



/**
* | output |
* | --- |
* | "Rank cards on a drag-and-drop board, then share it as a link, download it as an image, or rank live on stream." |
*
* @param {Help_Article_Tier_Lists_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_tier_lists_description = /** @type {((inputs?: Help_Article_Tier_Lists_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Tier_Lists_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordne Karten auf einem Drag-and-drop-Board, teile es dann als Link, lade es als Bild herunter oder ranke live im Stream.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classez des cartes sur un tableau en glisser-déposer, puis partagez-le par lien, téléchargez-le en image ou classez en direct sur votre stream.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("在可拖放的面板上给卡牌排名，然后分享为链接、下载为图片，或在直播中实时排名。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("在可拖放的面板上為卡牌排名，然後用連結分享、下載成圖片，或在直播中即時排名。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("끌어다 놓는 보드에서 카드 순위를 매긴 뒤 링크로 공유하거나 이미지로 저장하거나 방송에서 실시간으로 매겨 보세요.")
	return /** @type {LocalizedString} */ ("Rank cards on a drag-and-drop board, then share it as a link, download it as an image, or rank live on stream.")
});